import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTwitchAuthorizationQuery = createQueryHook(
  CreatorIntegrationsApiClient.getTwitchAuthorization,
  {
    queryKey: ['twitchAuthorization'],
  },
)
